const UNSIGNED_CLAIMS_KEY = 'unsigned';

/**
 * Checks whether visitor claims are set, as exposed by `visitor.isSet` in adaptive content expressions.
 *
 * Visitor claims are considered not set if:
 * - The object has no properties (i.e., `{}`), or
 * - The only property is `unsigned` but it is an empty object (i.e., `{ unsigned: {} }`).
 *
 * In all other cases, the claims are considered "set".
 */
export function isVisitorClaimsSet(claims: object): boolean {
    const props = Object.keys(claims);

    if (props.length === 0) {
        return false;
    }

    if (
        UNSIGNED_CLAIMS_KEY in claims &&
        typeof claims[UNSIGNED_CLAIMS_KEY] === 'object' &&
        claims[UNSIGNED_CLAIMS_KEY] !== null &&
        props.length === 1 &&
        Object.keys(claims[UNSIGNED_CLAIMS_KEY]).length === 0
    ) {
        return false;
    }

    return true;
}
